// While inside the menu containers for the navbar menus, allow the use of arrow keys to
// move focus around the items.
document.addEventListener("DOMContentLoaded", () => {
  const menuContainers = document.querySelectorAll(".nav-menu");

  menuContainers.forEach((menuContainer) => {
    const menuItems = Array.from(
      menuContainer.querySelectorAll('[role="menuitem"]')
    );

    menuContainer.addEventListener("keydown", (e) => {
      const currentIndex = menuItems.indexOf(document.activeElement);

      if (currentIndex === -1) return;

      let nextIndex;

      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          nextIndex = (currentIndex + 1) % menuItems.length;
          menuItems[nextIndex].focus();
          break;

        case "ArrowUp":
          e.preventDefault();
          nextIndex = (currentIndex - 1 + menuItems.length) % menuItems.length;
          menuItems[nextIndex].focus();
          break;
        default:
          break;
      }
    });
  });
});

// For the navigation menus items, when the trigger button is focused and the "down" key is pressed,
// navigate to the first menu item (similar to tab key was pressed).
document.addEventListener("DOMContentLoaded", () => {
  const menuTriggers = document.querySelectorAll(
    '[role="button"][data-toggle="collapse"]'
  );

  menuTriggers.forEach((trigger) => {
    trigger.addEventListener("keydown", (e) => {
      if (e.key === "ArrowDown") {
        e.preventDefault();

        // Get the menu ID from data-target or aria-controls
        const menuId =
          trigger.getAttribute("data-target") ||
          trigger.getAttribute("aria-controls");
        if (!menuId) return;

        // Remove leading '#' if present
        const cleanMenuId = menuId.replace(/^#/, "");

        const menuContainer = document.getElementById(cleanMenuId);
        if (!menuContainer) return;

        const menuItems = menuContainer.querySelectorAll("a[role='menuitem']");
        if (menuItems.length > 0) {
          menuItems[0].focus();
        }
      }
    });
  });
});
